import React from 'react';
import { isFloat } from '../helpers/isNumber';
import '../styles/stars.css';

export const generateStars = score => {
  let rows = [];
  let intScore = Math.floor(score);

  for (let i = 0; i < intScore; i++) {
    rows.push(<Star key={`filled-${i}`} filled={true} />);
  }

  isFloat(score) && rows.push(<HalfStar key="half" />) && intScore++;

  for (let n = 0; n < 5 - intScore; n++) {
    rows.push(<Star key={`no-filled-${n}`} filled={false} />);
  }

  return rows;
};

export const HalfStar = () =>
  <svg
    className="stars__element"
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="64"
    viewBox="0 0 56 54"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        id="a"
        d="M27.93 0l8.4 17.02 18.78 2.72L40.76 33l3.2 18.7-16.78-8.83-16.8 8.83 3.2-18.7L0 19.73l18.78-2.72L27.18 0"
      />
    </defs>
    <g>
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#D46D39" fillRule="nonzero" xlinkHref="#a" />
      <path fill="#ECEBE8" d="M27 0h28v52H27z" mask="url(#b)" />
    </g>
  </svg>;

export const Star = ({ filled }) =>
  <svg
    className="stars__element"
    width="67"
    height="64"
    viewBox="0 0 56 54"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.93 42.74l17.1 10.43-4.54-19.67 15.08-13.23-19.9-1.73L27.94 0l-7.77 18.54-19.9 1.73 15.1 13.23-4.52 19.67"
      fill={filled ? '#D46D39' : '#ECEBE8'}
      fillRule="evenodd"
    />
  </svg>;

const Stars = ({ score }) =>
  <div className="stars">
    {generateStars(score)}
  </div>;

export default Stars;



// WEBPACK FOOTER //
// ./src/components/Stars.js